"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HtmlInfoDisplay = void 0;
var _core = require("@dragon/core");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var HtmlInfoDisplay = exports.HtmlInfoDisplay = /*#__PURE__*/function () {
  function HtmlInfoDisplay(parent, containerClasses, classes, id, headerText, actionOnClick) {
    var _this = this;
    _classCallCheck(this, HtmlInfoDisplay);
    _defineProperty(this, "_id", void 0);
    _defineProperty(this, "_node", void 0);
    _defineProperty(this, "_value", void 0);
    _defineProperty(this, "_actionOnClick", void 0);
    this._id = id;
    this._node = document.createElement("div");
    this._node.className = "infodisplay " + containerClasses;
    this._actionOnClick = actionOnClick;
    var innerWrapper = document.createElement("div");
    innerWrapper.className = "innerWrapper";
    if (headerText) {
      var header = document.createElement("div");
      header.innerHTML = headerText;
      header.className = "header";
      innerWrapper.appendChild(header);
    }
    this._value = document.createElement("div");
    this._value.innerHTML = "";
    this._value.className = "value";
    innerWrapper.appendChild(this._value);
    this._node.onclick = function () {
      return _this.onClick();
    };
    this._node.appendChild(innerWrapper);
    parent.appendChild(this._node);
  }
  return _createClass(HtmlInfoDisplay, [{
    key: "value",
    set: function set(value) {
      this._value.innerHTML = value;
    }
  }, {
    key: "setClass",
    value: function setClass(name) {
      this._value.classList.add(name);
    }
  }, {
    key: "removeClass",
    value: function removeClass(name) {
      this._value.classList.remove(name);
    }

    /**
     * Note, for click to work the correct pointerevents needs to be set on the css for this element
     */
  }, {
    key: "onClick",
    value: function onClick() {
      if (this._actionOnClick) {
        _core.CORE.dispatch(this._actionOnClick);
      }
    }
  }]);
}();
//# sourceMappingURL=HtmlInfoDisplay.js.map